<template>
  <div class="sub-cidr-container">
    <el-table :data="subCidrTableData">
        <!--次要CIDR名称-->
        <el-table-column prop="name" key="name" min-width="200"
            :label="$t('subnet.text.subCidrName')">
            <template slot-scope="scope">
                <el-form :model="scope.row" :rules="rules" :ref="scope.$index + '_1'"
                    v-if="scope.row.isEditing">
                    <el-form-item prop="name" :show-message="false">
                        <el-input v-model="scope.row.name" :placeholder="$t('subnet.help.enterSubCidrName')" @blur="ruleFormTag.name=1"
                            @focus="ruleFormTag.name=0" >
                        </el-input>
                        <p v-if="ruleFormTag.name !== 0 && scope.row.name ===''"
                            class="el-form-item-help-error">
                            {{$t('create.placeholder.nameNull')}}
                        </p>
                        <p v-else class="el-form-item-name-help  input-tip"
                         :class="{'el-form-item-help-error': scope.row.name == 'error'}">
                        {{$t('subnet.help.subCidrTipPart1')}}
                        </p>
                    </el-form-item>
                </el-form>
                <span v-if="!scope.row.isEditing">
                    {{scope.row.name}}
                </span>
            </template>
        </el-table-column>
        <!--次要CIDR-->
        <el-table-column prop="subCidr" key="subCidr" min-width="200"
            :label="$t('subnet.text.subCidr')">
            <template slot="header">
                <span>{{$t('subnet.text.subCidr')}}</span>
                <el-tooltip effect="dark" style="margin-left:10px" placement="right">
                <div slot="content" class="my-create-tip">{{$t('subnet.help.onlyForCreateLocateIpAlias')}}</div>
                <a><i class="jc-icon-question"></i></a>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
                <el-form :model="scope.row" :rules="rules" :ref="scope.$index + '_2'"
                    v-if="scope.row.isEditing">
                    <el-form-item prop="subCidr" :show-message="false">
                        <el-input v-model="scope.row.subCidr" 
                            :placeholder="$t('subnet.help.enterSubCidr')"    @blur="ruleFormTag.subCidr=1" @focus="ruleFormTag.subCidr=0">
                        </el-input>
                        <p 
                            v-if="ruleFormTag.subCidr !== 0 && scope.row.subCidr ===''"
                            class="el-form-item-help-error">
                            {{$t('create.placeholder.subCidrNameNull')}}
                        </p>
                        <p 
                            v-else-if="subCidrCheckFailed"
                            class="el-form-item-help-error">{{subCidrCheckErrMsg}}</p>
                        <p v-else class="el-form-item-name-help input-tip" 
                            :class="{'el-form-item-help-error': scope.row.subCidr == 'error'}">
                        {{$t('subnet.help.subCidrTipPart2')}}
                      </p>
                    </el-form-item>
                </el-form>
                <span v-if="!scope.row.isEditing">
                    {{scope.row.subCidr}}
                </span>
            </template>
        </el-table-column>
        <!--操作-->
        <el-table-column 
            prop="operation" key="operation" min-width="100"
            :label="$t('listPage.tableLabel.operation')">
            <template slot-scope="scope">
                <!--保存-->
                <a href="javascript:void(0)" @click="saveSubCidr(scope, $event)" class="operation"
                    v-if="scope.row.isEditing">
                    {{$t('subnet.text.save')}}
                </a>
                <!--编辑-->
                <a href="javascript:void(0)" @click="editSubCidr(scope)"
                    v-if="!scope.row.isEditing">
                    {{$t('subnet.text.edit')}}
                </a>
                <!--删除-->
                <a href="javascript:void(0)" @click="deleteSubCidr(scope)">
                    {{$t('subnet.text.delete')}}
                </a>
            </template>
        </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { CidrRuleConstant} from '@/common/Constants';
export default {
    data() {
        const nameInputValidator = (rule, value, callback) => {
            const nameRegex = new RegExp('^[-0-9a-zA-Z_\\u4e00-\\u9fa5]{1,32}$');
            if (!value) {
                this.ruleFormTag.name=1
                return callback(new Error(this.$t('subnet.help.aliasIpCannotBeNull')));
            }
            if (!nameRegex.test(value)) {
                this.ruleFormTag.name='error'
                return callback(new Error());
            }
            callback();
        };
        const cidrInputValidator = (rule, value, callback) => {
            const ipRegex = CidrRuleConstant;
            if (!value) {
                this.ruleFormTag.subCidr = 1
                return callback(new Error(this.$t('subnet.help.aliasIpCannotBeNull')));
            }
            if (!ipRegex.test(value)) {
                this.ruleFormTag.subCidr = 'error'
                return callback(new Error(this.$t('subnet.help.cidrNotStandard')));
            }
            callback();
        };
        return {
            subCidrTableData: [],
            rules: {
                name: [
                    {
                        trigger: 'blur',
                        validator: nameInputValidator,
                    }
                ],
                subCidr: [
                    {
                        trigger: 'blur', validator: cidrInputValidator
                    }
                ]
            },
            ruleFormTag: {
                name: 0,
                subCidr: 0
            },
            subCidrCheckFailed: false,
            subCidrCheckErrMsg: ''
        };
    },
    props: {
        region: {
            type: String,
            default: ''
        },
        vpcId: {
            type: String,
            default: ''
        },
        cidr: {
            type: String,
            default: ''
        },
    },
    mounted() {
        this.addOneRow();
    },
    methods: {
        // 删除当前行
        deleteSubCidr() {
            this.subCidrTableData = [];
            this.subCidrCheckFailed = false;
            this.subCidrCheckErrMsg = '';
            this.addOneRow();
            this.$emit('update:visible', false);
            this.$emit('update:remainSubCidrQuantity', 1);
            this.$emit('update:addIconDisabled', false)
          // this.subCidrTableData.splice(scope.$index, 1);
        },
        // 保存当前行
        saveSubCidr(scope, e) {
            // 除点击事件外不触发
            if (!e.x || !e.y) return;
            let initValid = true;
            for (let i = 1; i <= 2; i++) {
                this.$refs[`${scope.$index}_${i}`].validate((valid) => {
                    initValid = initValid && valid;
                    if (!valid) {
                        return false;
                    }
                });
            }
            if (initValid) {
                const params = {
                    region: this.region,
                    cidr: this.cidr,
                    secondaryCidr: scope.row.subCidr,
                    vpcId: this.vpcId
                };
                this.subCidrCheckFailed = false
                Ajax.get('/api/cps/checkSubnets', params).then((res) => {
                    const subCidrInfo = {
                        secondaryCidrName: scope.row.name,
                        secondaryCidr: scope.row.subCidr
                    }
                    this.$emit('saveSubCidr',subCidrInfo)
                    scope.row.isEditing = false;
                })
                .catch(async (err) => {
                    const { response } = err.data;
                    try {
                        const json = await response.json();
                        if (json.errno === 10165) {
                          this.subCidrCheckFailed = true;
                          this.subCidrCheckErrMsg = json.errmsg;
                        }
                        if (this.subCidrCheckFailed) {
                          return false;
                        }
                        this.$message.error(json.errmsg);
                        console.log(json);
                    } catch (ex) {
                        console.log(ex);
                    }
                    this.hasConfirmClicked = false
                })
                .finally(() => {
                });
            }
        },
        // 编辑当前行
        editSubCidr(scope) {
            scope.row.isEditing = true;
        },
        // 添加一行
        addOneRow() {
            const row = {
                'name': '',
                'subCidr': '',
                isEditing: true
            };
            this.subCidrTableData.push(row);
        }
    }
};
</script>

<style lang="scss">
.sub-cidr-container{
    .cell{
        .el-form-item-name-help.input-tip{
            height: 32px;
        }
        .operation{
            margin-bottom: 18px
        }
    }
    .right-tips {
        position: absolute;
        z-index: 10;
        min-width: 100px;
        padding: 2px 10px;
        margin-top: 8px;
        background: #fff;
        line-height: 20px;
        border: 1px solid #dde4eb;
        color: #999;
    }
    .not-in-range-tips {
        color: red !important;
        border: 1px solid red;
    }
    .subnet-failed:after {
        left: 19px;
    }

    .subnet-failed{
        min-width: 150px
    }
    .down-arrow-select {
        display: inline-block;
        position: absolute;
        width: 40px;
        height: 30px;
        margin-right: 20px;
        z-index: 10;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/subnet/subCidr/SubCidr.vue